import { render, staticRenderFns } from "./Destroyer.vue?vue&type=template&id=74828fd6"
import script from "./Destroyer.vue?vue&type=script&lang=js"
export * from "./Destroyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports